export const routes = {
    home: '/',
    dashboard: '/dashboard'
};

export const navigateTo = {
    home: routes.home,
    dashboard: routes.dashboard
};